<template>
  <div>
    <vue-html2pdf
      :show-layout="true"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Rapor"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="auto"
      ref="html2Pdf">
      <section slot="pdf-content">
        <div class="reportHeader">
          <img src="../../../../assets/img/reportLogo.png" class="logo" alt="SanatTeknoloji" width="300" style="padding: 1rem">
          <div class="info" style="width: 50%">
            <ul>
              <li> <strong> Sanat Teknoloji </strong></li>
              <li> <strong> Adres: </strong> Atakent Mah., Atakan Cad., Öncü Sok. 9/A, 34760 Ümraniye/İstanbul </li>
              <li> <strong> Telefon: </strong> 0850 259 00 99 </li>
              <li> <strong> E-posta: </strong> destek@sanatteknoloji.com.tr </li>
              <li> <strong> Web Sitesi: </strong> <a target="_blank" href="https://sanatteknoloji.com.tr/"> sanatteknoloji.com.tr </a> </li>
            </ul>
          </div>
        </div>
        <div class="report-details">
          <div class="head">
            <div class="title"> </div>
            <div class="info">
              <ul>
                <li> <strong> Oluşturma Tarihi:  </strong> {{moment(data.dealer.reported_date)}}</li>
                <li> <strong> Randevu Tarihi:  </strong> {{moment(data.dealer.appointment_date)}}</li>
                <li> <strong> Servis Durumu:  </strong> 
                    <b-badge variant="danger" v-if=" data.dealer.status == 'open' "> Açık </b-badge>
                    <b-badge variant="success" v-else> Kapalı </b-badge>
                </li>
                <li> <strong> Servis Tipi:  </strong> 
                    <b-badge variant="warning" v-if=" data.dealer.type == 'fault' "> Teknik Servis </b-badge>
                    <b-badge variant="primary" v-else> Yeni Kurulum </b-badge>
                </li>
                <li> <strong> Hizmet Alan Müşteri: </strong> {{data.dealer.customer.name}}</li>
                <li> <strong> Hizmet Veren Firma:  </strong> {{data.dealer.company.name}}</li>
                <li> <strong> İlgili Ürün:  </strong> {{data.dealer.product.name}}</li>
                <li>
                   <strong> İlgili Teknisyen:  </strong> 
                   {{data.dealer.user.first_name + ' ' +data.dealer.user.last_name}}
                   ({{data.dealer.user.username}})
                </li>
              </ul>
            </div>
          </div>
          <div class="body">
            <div class="title">Detaylar</div>
            <hr />
             <p> 
                <strong> Servis Konusu: </strong>
                <span v-html="data.dealer.content"> </span>
              </p>
              <Map :address="data.dealer.customer.address+' '+data.dealer.customer.town+' / '+data.dealer.customer.city+' / '+ data.dealer.customer.country" />
          </div>
          <div class="comments">
            <div class="title">İşlemler</div>
             <Table :fields="fields" :items="list" :filtered="filtered" type="List" :loading="loading"  noHeader mode="comp"/>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div> 
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'
import Map from "@/components/Map";
import Table from "@/components/Table"
 let fields = [ 
        { key: 'date', type: 'date', label: 'İşlem Tarihi', keys:['date']},
        { key: 'name', label: 'Yetkili Adı', keys:['person_name']},
        { key: 'surname', label: 'Yetkili Soyadı', keys:['person_surname'] },
        { key: 'desc', label: 'İşlem', keys:['description'] },
        { key: 'detection', label: 'Tespit', keys:['detection'] },    
  ]; 

  let filtered = ['date',"name", 'surname', 'desc', 'detection']; 

export default {
  name: "TicketReport",
  data: function(){
    return{
      fields, filtered
    }
  },
  props: {
    data: Object,
    modalName: String,
    modalEvent: Function,
    save: Boolean,
    saveState: Function,
    formName: String
  },
  components: {
    VueHtml2pdf, Map, Table
  },
  computed: {
   
    list() {
      return this.$store.getters.serviceMovementsList

    }
  },
  methods: {
    moment: function (date) {
      return moment(date.substring(0,19)).format('DD MMMM YYYY HH:mm:ss');
    },
  },
  watch: {
    save: async function(data){
      if(data) {
        this.$refs.html2Pdf.generatePdf()
      }
      this.saveState(false)
    },
  },
}
</script>

<style lang="css" scoped > 
  @import "../styles/report.min.css"; 
</style>



// WEBPACK FOOTER //
// src/pages/General/Dealer/modals/Report.vue